import { render, staticRenderFns } from "./saalplan-show.vue?vue&type=template&id=6fcefb39&scoped=true&lang=pug&"
import script from "./saalplan-show.vue?vue&type=script&lang=js&"
export * from "./saalplan-show.vue?vue&type=script&lang=js&"
import style0 from "./saalplan-show.vue?vue&type=style&index=0&id=6fcefb39&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcefb39",
  null
  
)

export default component.exports